import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import LogRocket from 'logrocket';
import createLogRocketPlugin from 'logrocket-vuex';
const logrocketPlugin = createLogRocketPlugin(LogRocket);

// LogRocket.init('9djayc/vpop3-webmail');

const getBrowserLanguage = () => {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  } else {
    return navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    loginError: '',
    loginPending: false,
    username: '',
    folders: { dispName: 'Root', unread: 0, parent: null, children: {} },
    foldersLoaded: false,
    settings: {
      manualrules: [],
      selectedCalendars: {},
      canchangepassword: true,
      cansetforwards: true,
      allowchangeautoresponders: true
    },
    settingsLoaded: false,
    specialFolders: {},
    allowedImagesSender: {},
    calendars: [],
    newRule: null,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    },
    sentryEnabled: false,
    internalTrackEnabled: false,
    logrocketInitialised: false,
    smartlookInitialised: false,
    messageEditorMode: 0,
    senderAddress: '',
    senderName: '',
    collectedAddresses: {},
    addressBookScopes: [],
    addressBookEntries: {},
    language: localStorage.getItem('webmailLanguage') || getBrowserLanguage(),
    availableLanguages: {}
  },
  mutations,
  getters,
  actions,
  modules: {
  },
  plugins: [ logrocketPlugin ]
});
